export default __webpack_public_path__ + "static/media/liberty-arm.3562605e.svg";